
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 155521"}},[_c('g',{attrs:{"fill":"none","stroke":"#F5CF37","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/edit-2"}},[_c('path',{attrs:{"d":"M9.945 2.7L3.788 9.221a2.287 2.287 0 00-.5 1.073l-.28 2.427a1.145 1.145 0 001.4 1.328l2.415-.412a2.153 2.153 0 001.042-.563l6.158-6.517c1.065-1.125 1.545-2.407-.113-3.975-1.647-1.554-2.9-1.007-3.965.118z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M8.918 3.787a4.6 4.6 0 004.087 3.863M2.25 16.5h13.5","opacity":".4"}})])])])
          )
        }
      }
    